// src/stores/useCookieConsentStore.ts
// Tracks cookie consent status. Mirrors the pattern of other small stores.
// localStorage key: 'cookieConsent'  — values: 'accepted' | 'declined' | (absent)

import { create } from 'zustand';

type ConsentStatus = 'accepted' | 'declined' | null;

const LS_KEY = 'cookieConsent';

function readStorage(): ConsentStatus {
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v === 'accepted' || v === 'declined') return v;
  } catch {
    // localStorage unavailable (private browsing edge case)
  }
  return null;
}

interface CookieConsentState {
  status: ConsentStatus;
  accept:  () => void;
  decline: () => void;
}

export const useCookieConsentStore = create<CookieConsentState>((set) => ({
  status: readStorage(),

  accept: () => {
    try { localStorage.setItem(LS_KEY, 'accepted'); } catch { /* ignore */ }
    set({ status: 'accepted' });
  },

  decline: () => {
    try { localStorage.setItem(LS_KEY, 'declined'); } catch { /* ignore */ }
    set({ status: 'declined' });
  },
}));